import React, { useState, useEffect, useRef } from "react";
import DataTable from 'react-data-table-component';
import DataTableExtensions from "react-data-table-component-extensions";
import "react-data-table-component-extensions/dist/index.css";
import { Link, useLocation } from 'react-router-dom';

//import BaseTable, { Column } from 'react-base-table'
import 'react-base-table/styles.css'

import { api_crud_route, api_list_route, api_list_order, api_crud_base, endpoints } from './Config';

import { reqGET, reqDELETE } from '../../../../Utils';
import { getTokenInfo } from '../../../../UseToken';
import UseSidebar from '../../../../UseSidebar';

import Loader from '../../../Loader/Loader';

import Swal from 'sweetalert2'

import { language } from './Language';

export default function List() {
    const [, set_dados] = useState(null);
    const permissions = useRef(null);
    const intervention = useRef(null);
    const [document_state_list, set_document_state_list] = useState([])

    const [data, setData] = useState([]);
    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState('pt');

    const { pathname } = useLocation()
    // const [permissions, set_permissions] = useState({})    

    const handleRowClick = (id) => {
        document.getElementById('c_' + id)?.click();
    };

    /*
    const get_info = async () => {
        await reqGET(api_list_route(getTokenInfo().companycode))
            .then(res => {
                if (res.data[0] !== undefined)
                    setData(res.data);
            })
            .catch(() => 404
            )
    }
    */

    const get_info = async () => {
        await reqGET(`${api_crud_base}/intranet/maintenance/type/${getTokenInfo().companycode}/intervention`)
            .then(res => {
                if (res.data[0] !== undefined)
                    setData(res.data);
            })
            .catch(() => 404)
    }

    let get_permissions = async (e, sidebar) => {
        let handleSingleCheck = async (e, sidebar) => {
            const name = e;

            let ver_submenu = async (node) => {
                if (node.submenu.length !== 0) {

                    // node.submenu.forEach(subitem => {
                    for await (let subitem of node.submenu) {

                        if (subitem.path === name) {

                            let aux = {}
                            if (permissions.current !== null) {
                                aux = permissions.current

                                if (aux.create !== true) {
                                    aux.create = subitem.create
                                }
                                if (aux.edit !== true) {
                                    aux.edit = subitem.edit
                                }
                                if (aux.remove !== true) {
                                    aux.remove = subitem.remove
                                }
                            }
                            else {
                                aux = { create: subitem.create, edit: subitem.edit, view: true, remove: subitem.remove }
                            }

                            // set_permissions({ edit: subitem.edit, view: true, remove: subitem.remove })
                            set_dados(permissions.current = aux)
                        }
                        else {
                            await ver_submenu(subitem)
                        }

                    }
                }
            }

            // sidebar.forEach(node => {
            for await (let node of sidebar) {
                if (node.path === name) {

                    let aux = {}
                    if (permissions.current !== null) {
                        aux = permissions.current

                        if (aux.create !== true) {
                            aux.create = node.create
                        }
                        if (aux.edit !== true) {
                            aux.edit = node.edit
                        }
                        if (aux.remove !== true) {
                            aux.remove = node.remove
                        }
                    }
                    else {
                        aux = { create: node.create, edit: node.edit, view: true, remove: node.remove }
                    }

                    // set_permissions({ edit: node.edit, view: true, remove: node.remove })
                    set_dados(permissions.current = aux)

                    if (Array.isArray(node.submenu) && node.submenu.length > 0) {
                        await ver_submenu(node)
                    }

                } else
                    await ver_submenu(node)
            }
        }

        await handleSingleCheck(e, sidebar)
    }

    useEffect(() => {

        (async () => {

            let aux_document_state = [
                {
                    id: 0,
                    label: 'Em edição'
                },
                {
                    id: 1,
                    label: 'Aguarda aprovação'
                },
                {
                    id: 2,
                    label: 'Em revisão'
                },
                {
                    id: 3,
                    label: 'Aprovado'
                },
                {
                    id: 4,
                    label: 'Obsoleto'
                },
                {
                    id: 5,
                    label: 'Eliminado'
                }
            ]
            set_document_state_list(aux_document_state)

            await get_info()
            //await interventions()

            set_lang(localStorage.getItem('lang'))

            await UseSidebar().getSidebar(getTokenInfo().profile).then(async (v) => { await get_permissions(pathname, v) })

            if (getTokenInfo().entity_profile !== undefined && Array.isArray(getTokenInfo().entity_profile)) {

                for await (let el of getTokenInfo().entity_profile) {
                    await UseSidebar().getSidebarEntity(el.name).then(async (v) => { await get_permissions(pathname, v) })
                }

            }

            setLoading(false)

        })()

    }, [pathname]);

    //APAGAR REGISTO
    function apagar(id) {

        Swal.fire({
            title: language[lang].delete_title,
            text: language[lang].delete_text,
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#0095e8',
            cancelButtonColor: '#d9214e',
            confirmButtonText: language[lang].delete_confirm,
            cancelButtonText: language[lang].delete_cancel
        })
            .then((result) => {
                if (result.isConfirmed) {
                    reqDELETE(api_crud_route, { id: id })
                        .then(res => {
                            //props.history.push(endpoints.list);
                        })
                        .catch(error => console.log(error))
                }
            })
    }

    function parseCost(cost) {
        if (!cost) return 0;

        const normalized = String(cost)
            .replace(/[^\d.,]/g, '')
            .replace(',', '.');

        const parsed = parseFloat(normalized);
        return isNaN(parsed) ? 0 : parsed;
    }

    { console.log('data', data) }

    const columns = [
        {
            name: language[lang].field_tag,
            selector: row => row.id,
            width: '10%',
            minWidth: '100px',
            sortable: true,
            right: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {row.id}
                </Link>
            ),
        },
        {
            name: language[lang].field_code_tag,
            selector: row => row.info?.equipment?.cod || '',
            width: '10%',
            minWidth: '100px',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {row.info?.equipment?.cod || ''}
                </Link>
            ),
        },
        {
            name: language[lang].field_name,
            selector: row => row.info?.equipment?.name || '',
            width: '40%',
            minWidth: '200px',
            sortable: true,
            left: true,
            cell: (row) => (
                <Link
                    to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                    style={{ textDecoration: 'none', color: 'inherit' }}
                >
                    {row.info?.equipment?.name || ''}
                </Link>
            ),
        },
        {
            name: language[lang].tecnicos,
            cell: row => {
                const actions = Array.isArray(row.info?.action) ? row.info.action : [];
                const names = actions.map(a => a?.responsavel?.name).filter(Boolean);
                const visible = names.slice(0, 2).join(', ');
                const hidden = names.slice(2);

                return (
                    <Link
                        to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        {visible}
                        {hidden.length > 0 && (
                            <span
                                title={hidden.join(', ')}
                                style={{ marginLeft: '4px', color: '#007bff', cursor: 'pointer' }}
                            >
                                +{hidden.length} {language[lang].more}
                            </span>
                        )}
                    </Link>
                );
            },
            width: '25%',
            minWidth: '100px',
            sortable: true,
            left: true,
        },
        {
            name: language[lang].field_cost,
            selector: row => {
                const actions = (row.info?.action || []).reduce((acc, item) => acc + parseCost(item?.cost), 0);
                const services = (row.info?.service || []).reduce((acc, item) => acc + parseCost(item?.cost), 0);
                const utilities = (row.info?.utilities || []).reduce((acc, item) => acc + parseCost(item?.cost), 0);
                return actions + services + utilities;
            },
            cell: (row) => {
                const actions = (row.info?.action || []).reduce((acc, item) => acc + parseCost(item?.cost), 0);
                const services = (row.info?.service || []).reduce((acc, item) => acc + parseCost(item?.cost), 0);
                const utilities = (row.info?.utilities || []).reduce((acc, item) => acc + parseCost(item?.cost), 0);
                const total = actions + services + utilities;

                return (
                    <Link
                        to={{ pathname: endpoints.regist, state: { item: row, operation: 'edit' } }}
                        style={{ textDecoration: 'none', color: 'inherit' }}
                    >
                        {total > 0 ? `${total.toFixed(2)} €` : ''}
                    </Link>
                );
            },
            width: '15%',
            minWidth: '100px',
            sortable: true,
            right: true,
        },

    ];

    const defaultComponentOptions = {
        rowsPerPageText: language[lang].table_rows_per_page,
        rangeSeparatorText: language[lang].table_separator,
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: language[lang].table_all,
    };

    const tableData = {
        columns,
        data: [...data].sort((a, b) => Number(b.id) - Number(a.id)),
        filterPlaceholder: language[lang].filter_placeholder,
        export: false,
        print: false
    };

    return (isloading ?

        <Loader />

        :

        <main>
            <div className={`dash-cards header`}>
                <div className="container">
                    <h2 className="dash-title">{language[lang].component_list}</h2>
                    <p>{language[lang].component} / {language[lang].component_list}</p>
                </div>
            </div>

            <div className={`dash-cards body`}>
                <div className="container">

                    <div className="card mb-5 mb-xl-8">
                        <div className="card-body">

                            <div className="pb-10">
                                <div className="div-table">
                                    <div className="table-header text-end mb-8 d-none">
                                        <Link className="btn rounded-pill btn-primary py-1 px-4 multi-item"
                                            to={{ pathname: endpoints.regist }}
                                            style={{ padding: '0.15rem 1.0rem', fontSize: '0.9rem' }}
                                        >
                                            <span>{language[lang].add_new}</span>
                                        </Link>
                                    </div>
                                    <div className="table-body">
                                        <DataTableExtensions {...tableData}>
                                            <DataTable
                                                noDataComponent={language[lang].table_empty}
                                                noHeader
                                                pagination
                                                exportHeaders
                                                paginationComponentOptions={defaultComponentOptions}
                                                paginationPerPage={25}
                                                paginationRowsPerPageOptions={[25, 50, 100]}
                                                onRowClicked={(row) => handleRowClick(row.id)}
                                            />
                                        </DataTableExtensions>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </main>
    )
}